"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBarChartDataDataSet = getBarChartDataDataSet;
exports.getBarChartOptions = getBarChartOptions;

var _utils = require("../utils");

function getBarChartDataDataSet(data) {
  return {
    labels: data.map(function (d) {
      return d.date;
    }),
    datasets: [{
      label: '% Total idea votes delivered',
      fill: false,
      data: data.map(function (value) {
        var totalVotes = value.open + value.delivered;
        var percentVotesDelivered = 0;

        if (totalVotes > 0) {
          percentVotesDelivered = value.delivered / (value.open + value.delivered) * 100;
        }

        return Number(percentVotesDelivered.toFixed(2));
      }),
      borderColor: _utils.BRAND_BLUE,
      backgroundColor: _utils.BRAND_BLUE
    }]
  };
}

function getBarChartOptions() {
  return {
    title: {
      display: false
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 24
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      intersect: false,
      mode: 'x',
      callbacks: {
        title: function title() {
          return '';
        }
      }
    },
    legend: {
      display: false,
      position: 'top',
      align: 'start',
      labels: {
        boxWidth: 12
      }
    },
    scales: {
      xAxes: [{
        offset: true,
        type: 'time',
        time: {
          minUnit: 'month'
        },
        gridLines: {
          display: false
        },
        ticks: {
          maxRotation: 0,
          callback: function callback(value) {
            return "      ".concat(value, "      ");
          }
        }
      }],
      yAxes: [{
        gridLines: {
          borderDash: [8, 4],
          color: _utils.BRAND_BORDER_GREY,
          drawBorder: false
        },
        ticks: {
          padding: 16,
          beginAtZero: true
        }
      }]
    },
    plugins: {
      datalabels: {
        display: false
      },
      crosshair: {
        line: {
          color: _utils.BRAND_GREY,
          width: 0.5
        },
        zoom: {
          enabled: false
        },
        sync: {
          enabled: false
        }
      }
    }
  };
}